module.exports = __webpack_public_path__ + "static/media/icon3.6415fa79.png";